// extracted by mini-css-extract-plugin
module.exports = {"flex_display":"styles_flex_display__Bo4qf","heading":"styles_heading__BpYgx","action_grid_container":"styles_action_grid_container___F5vJ"};